import { FC, PropsWithChildren } from 'react';

import {
  AffinityTrendsDeltaContentContainer,
  AffinityTrendsDeltaContentTitle,
  AffinityTrendsDeltaLink,
  AffinityTrendsDeltaUnscoredTitleContainer,
} from 'modules/intelligentInsights/brandAffinityInsights/components/affinityTrends/AffinityTrends.styles';
import {
  AFFINITY_BREAKDOWN_ANCHOR,
  AFFINITY_TRENDS_DELTA_LINK_TEXT,
  AFFINITY_TRENDS_DELTA_TOGGLE_TIP_TEXT,
} from 'modules/intelligentInsights/brandAffinityInsights/constants';
import { useCoreContext } from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/CoreContext';
import { BrandAffinityLevel } from 'modules/domains';
import { HelpToggletip, TipPlacement } from 'ui/tooltip';
import { colors } from 'ui/theme';

export interface AffinityTrendsDeltaContentProps {
  displayUnscoredTip?: boolean;
  label: BrandAffinityLevel;
  titleText: string;
}
export const AffinityTrendsDeltaContent: FC<PropsWithChildren<AffinityTrendsDeltaContentProps>> = ({
  children,
  displayUnscoredTip,
  label,
  titleText,
  ...rest
}) => {
  const { setSelectedAffinityTab } = useCoreContext();
  const navigateToAffinityBreakdown = () => {
    setSelectedAffinityTab(label);
    const element = document.getElementById(AFFINITY_BREAKDOWN_ANCHOR);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  return (
    <AffinityTrendsDeltaContentContainer {...rest}>
      <AffinityTrendsDeltaUnscoredTitleContainer>
        <AffinityTrendsDeltaContentTitle>{titleText}</AffinityTrendsDeltaContentTitle>
        {displayUnscoredTip && (
          <HelpToggletip
            iconProps={{ color: colors.secondaryText, height: 16, width: 16 }}
            tooltipContent={AFFINITY_TRENDS_DELTA_TOGGLE_TIP_TEXT}
            placement={TipPlacement.Top}
          />
        )}
      </AffinityTrendsDeltaUnscoredTitleContainer>

      {children}
      <AffinityTrendsDeltaLink
        tabIndex={0}
        role="link"
        aria-label="Affinity Breakdown Link"
        onClick={navigateToAffinityBreakdown}
      >
        {AFFINITY_TRENDS_DELTA_LINK_TEXT}
      </AffinityTrendsDeltaLink>
    </AffinityTrendsDeltaContentContainer>
  );
};
